export interface Folder {
    id: number;
    name: string;
    userName: string;
    children?: Array<Folder>;
    visibleCount: number;
    count: number;
    order: number;
    parent: number;
    creatorId: number;
    edit?: boolean;
}

export const initialFolder: Readonly<Folder> = {
    id: 0,
    name: '',
    userName: '',
    children: [],
    visibleCount: 0,
    count: 0,
    order: null,
    parent: null,
    creatorId: 0,
};
